import React from 'react';
import { useSelector } from 'react-redux';
import LicenseMetrics from '../../licenseMetrics';
import TimelineComponent from '../../graphComponents/timelineComponent';
import RankingComponent from '../../graphComponents/rankingComponent';
import ROIComponent from '../../graphComponents/ROIComponent';
import BenchMarkingComponent from '../../graphComponents/benchMarkingComponent';
import '../../licenseAnalyticsPage/FinancePageLayout.css';
import {
  getChangingRooms,
  getFacilitiesCosts,
  getTotalPitches,
  getFacilitiesYoyValues,
  getClubValue,
} from '../../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import { shortenNumber } from '../../licenseAnalyticsSupport/calculationsUtils';
import { PAGE } from '../../licenseAnalyticsSupport/typeInterfaces';
import { useTranslation } from 'react-i18next';

const FacilitiesLayoutPage = React.memo(() => {
  const changingRoomsCount = useSelector(getChangingRooms);
  const facilityCost = useSelector(getFacilitiesCosts);
  const totalPitches = useSelector(getTotalPitches);
  const getYOYValues = useSelector(getFacilitiesYoyValues);
  const [t] = useTranslation();
  const club = useSelector(getClubValue);
  const prefix = club ? t('DC_5_CLUB') : t('AVERAGE');

  return (
    <div className="container">
      <div className="a commonBox box1">
        <LicenseMetrics
          title={prefix + ' ' + t('DC_3_FACILITIES') + ' ' + t('COST')}
          spendValue={shortenNumber(facilityCost) || '-'}
          metricsValue={getYOYValues.value1}
          showYen={true}
          showYOY
        />
      </div>
      <div className="b commonBox box1">
        <LicenseMetrics
          title={prefix + ' ' + t('TOTAL_PITCHES')}
          spendValue={totalPitches.toFixed() || '-'}
          metricsValue={getYOYValues.value2}
          showYOY
        />
      </div>
      <div className="c commonBox box1">
        <LicenseMetrics
          title={prefix + ' ' + t('DC_CAP_CHANGING_ROOMS')}
          spendValue={changingRoomsCount.toFixed() || '-'}
          metricsValue={getYOYValues.value3}
          showYOY
        />
      </div>

      <div className="d commonBox">
        <TimelineComponent page={PAGE.FACILITIES} departments={[]}/>
        {/* <RankingComponent page={PAGE.FACILITIES} /> */}
        <RankingComponent />
      </div>
      <div className="e commonBox">
        <ROIComponent page={PAGE.FACILITIES} departments={[]}/>
      </div>
      <div className="f commonBox">
        <BenchMarkingComponent page={PAGE.FACILITIES} departments={[]}/>
      </div>
    </div>
  );
});

export default FacilitiesLayoutPage;
